
import { IFreehandShapeUponCreation, IZoneMapLocationUponCreation } from './types';
import { ZoneEntity, ZoneType } from '@src/core/features';

export interface IZonesInitialState {
  selectedZone: ZoneEntity | null;
  /** Sidebar hover (safe-land list) — map uses `ArcSafeLand.selected` for this id. */
  hoveredSafeLandZoneId: number | null;
  collapse: {
    [ZoneType.TEMPORARY]: boolean;
    [ZoneType.PERMANENT]: boolean;
  };
  zoneMapLocationUponCreation: IZoneMapLocationUponCreation | null;
  freehandShapeUponCreation: IFreehandShapeUponCreation | null;
}

const initialState: IZonesInitialState = {
  selectedZone: null,
  hoveredSafeLandZoneId: null,
  collapse: {
    [ZoneType.TEMPORARY]: true,
    [ZoneType.PERMANENT]: true,
  },
  zoneMapLocationUponCreation: null,
  freehandShapeUponCreation: null,
};

export default initialState;
